import {useNotifications} from "../../context/NotificationContext";
import {useMutation} from "react-query";
import {NoteFormData, UpdateNoteData} from "../../types/Note";
import ngage from "../../services/ngage";
import {FormikHelpers} from "formik";
import {invalidate} from "../../services/query-client";
import {stripKeyFromObject} from "../../services/object";

export function useUpdateNote() {
  const {notify} = useNotifications();
  const update = useMutation(({id, data}: { id: number, data: UpdateNoteData}) => ngage.notes.update(id, data));

  async function updateNote(id: number, values: NoteFormData, formik: FormikHelpers<NoteFormData>) {
    try {
      const noteData = stripKeyFromObject(values, 'mode') as UpdateNoteData;

      // Make the note and invalidate the note cache
      await update.mutateAsync({id, data: noteData});
      await invalidate('notes.all');
      await invalidate(['notes', {id}]);

      // Mark the form as having been submitted
      formik.setSubmitting(false);

      // Notify the user
      notify("success", "Note Updated", `${values.title} has been updated`);
      return true;
    } catch (error) {
      notify("error", "Note Not Updated", `${values.title} could not be updated`);
      throw error;
    }
  }

  return updateNote;
}